import { render, staticRenderFns } from "./feelingCard.vue?vue&type=template&id=52aef8ea&scoped=true&"
import script from "./feelingCard.vue?vue&type=script&lang=js&"
export * from "./feelingCard.vue?vue&type=script&lang=js&"
import style0 from "./feelingCard.vue?vue&type=style&index=0&id=52aef8ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aef8ea",
  null
  
)

export default component.exports